import Forbidden from '@/components/errors/Forbidden';

export default {
  components: {
    Forbidden,
  },
  data() {
    return {
      forbidden: false,
    };
  },
  mounted() {
    // Now when we have all the permissions update via pusher this is not needed.
    // window.eventBus.$on('403', this.accessDenied);
  },
  methods: {
    accessDenied() {
      this.forbidden = true;
    },
  },
};
